import {
  BulkUpdateInvoicesToPaidResponse,
  BulkUpdateInvoicesToPaidResult,
} from './bulkUpdateInvoicesToPaidTypes';

export function isBulkUpdateInvoicesToPaidResponse(
  data: unknown
): data is BulkUpdateInvoicesToPaidResponse {
  if (!data || typeof data !== 'object') {
    return false;
  }

  if (!('successfulInvoiceIds' in data) || !('failedInvoices' in data)) {
    return false;
  }

  const { successfulInvoiceIds, failedInvoices } = data;

  if (!Array.isArray(successfulInvoiceIds) || !Array.isArray(failedInvoices)) {
    return false;
  }

  return failedInvoices.every(
    (item) =>
      typeof item === 'object' &&
      item !== null &&
      'invoiceId' in item &&
      'errorMessage' in item &&
      typeof item.invoiceId === 'string' &&
      typeof item.errorMessage === 'string'
  );
}

export function mapBulkUpdateInvoicesToPaidResponse(
  response: BulkUpdateInvoicesToPaidResponse
): BulkUpdateInvoicesToPaidResult {
  return {
    successCount: response.successfulInvoiceIds.length,
    failureCount: response.failedInvoices.length,
    successfulInvoiceIds: response.successfulInvoiceIds,
    failedInvoices: response.failedInvoices,
  };
}

